import React from 'react';
import type { TimeRangePickerProps } from 'antd';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs';
import { useCustomerContext } from 'src/app/contexts/customer';
import { IDate } from '@contexts';

const { RangePicker } = DatePicker;

const rangePresets: TimeRangePickerProps['presets'] = [
    { label: 'Last 7 Days', value: [dayjs().add(-7, 'd'), dayjs()] },
    { label: 'Last 14 Days', value: [dayjs().add(-14, 'd'), dayjs()] },
    { label: 'Last 30 Days', value: [dayjs().add(-30, 'd'), dayjs()] },
    { label: 'Last 90 Days', value: [dayjs().add(-90, 'd'), dayjs()] },
];

interface IDateRangeProps {
    setDate?: (date: IDate) => void;
}

const DateRange: React.FC<IDateRangeProps> = ({ setDate }: IDateRangeProps) => {
    const onRangeChange = (dates: null | (Dayjs | null)[], dateStrings: string[]) => {
        if (dates) {
            setDate &&
                setDate({
                    startDate: dateStrings[0],
                    endDate: dateStrings[1],
                });
        } else {
            setDate &&
                setDate({
                    startDate: '',
                    endDate: '',
                });
        }
    };
    return <RangePicker presets={rangePresets} onChange={onRangeChange} />;
};

export default DateRange;
